var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.25 42.9398L54.25 19.0601C54.2481 18.7152 54.1554 18.3768 53.981 18.0792C53.8067 17.7815 53.557 17.5351 53.257 17.3648L31.9445 5.3765C31.6574 5.2107 31.3316 5.12341 31 5.12341C30.6684 5.12341 30.3426 5.2107 30.0555 5.3765L8.74297 17.3648C8.44302 17.5351 8.19329 17.7815 8.01896 18.0792C7.84462 18.3768 7.75185 18.7152 7.75 19.0601L7.75 42.9398C7.75185 43.2847 7.84462 43.6231 8.01896 43.9207C8.19329 44.2183 8.44302 44.4648 8.74297 44.6351L30.0555 56.6234C30.3426 56.7892 30.6684 56.8765 31 56.8765C31.3316 56.8765 31.6574 56.7892 31.9445 56.6234L53.257 44.6351C53.557 44.4648 53.8067 44.2183 53.981 43.9207C54.1554 43.6231 54.2481 43.2847 54.25 42.9398V42.9398Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9836 18.0671L31.218 31L8.0164 18.0671",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.218 30.9999L31 56.8656",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.8e34a769581b492fb22acbd68b566901.svg";
export { ForwardRef as ReactComponent };